import React from "react";
import { t } from "i18next";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import DesignDivers from "../../Common/DesignDivers";
import IconesDivers from "../../Common/IconesDivers";
import ButtonsDivers from "../../Common/ButtonsDivers";
import ConnectiviteDivers from "../../Common/ConnectiviteDivers";
import classNames from "classnames";
import PopupGeneral from "./PopupGeneral";
import { useSelector } from "react-redux";
function Divers() {
    const mainColor = useSelector(
        (state: any) => state.global.infoUser.maincolor
    );
    const [activeTab, setActiveTab] = React.useState<number>(0);

    const tabs = [
        {
            title: t("Divers"),
            content: (
                <div
                    style={{
                        height: "100vh",
                        padding: "20px",
                        overflowY: "auto",
                        paddingBottom: "300px",
                    }}
                >
                    {" "}
                    <PopupGeneral />
                    <DesignDivers path={["template", "SiteWeb", "Divers"]} />
                    <ButtonsDivers />
                    <IconesDivers />
                    <ConnectiviteDivers
                        path={["template", "SiteWeb", "Divers", "SocialMedia"]}
                    />
                </div>
            ),
            customClassName: "",
        },
    ];

    function toggleNav(tab: number) {
        if (activeTab !== tab) {
            setActiveTab(tab);
        }
    }
    return (
        <React.Fragment>
            <div style={{ borderBottom: "1px solid #ddd4d4" }}>
                <Nav
                    tabs
                    style={{
                        backgroundColor: "white",
                        gridTemplateColumns: `repeat(${tabs.length}, 1fr)`,
                        border: "unset",
                    }}
                >
                    {tabs.map((element, index) => (
                        <NavItem
                            key={index}
                            className={classNames(
                                "pb-1",
                                "d-flex align-items-center text-nowrap",
                                {
                                    "disable-nav-item__clz":
                                        activeTab !== index,
                                },
                                element.customClassName
                            )}
                            style={{
                                cursor: "pointer",
                                borderBottom:
                                    activeTab === index
                                        ? `${mainColor} 3px solid`
                                        : "",
                            }}
                        >
                            <NavLink
                                className={classNames("text-dark w-100", {
                                    "active customer-account-menu-nav-link-active__clz":
                                        activeTab === index,
                                    "customer-account-menu-nav-link-disable__clz":
                                        activeTab !== index,
                                })}
                                onClick={() => toggleNav(index)}
                            >
                                <span
                                    className="px-2"
                                    style={{
                                        font:
                                            "normal normal 600 20px/27px Segoe UI",
                                        marginRight: index === 0 ? "20px" : "0",
                                    }}
                                >
                                    {element.title}
                                </span>
                            </NavLink>
                        </NavItem>
                    ))}
                </Nav>
            </div>
            <TabContent activeTab={activeTab} className="h-100">
                {tabs.map((element, index) => (
                    <TabPane
                        tabId={index}
                        key={index}
                        style={{ height: "100%" }}
                    >
                        {element.content}
                    </TabPane>
                ))}
            </TabContent>
        </React.Fragment>
    );
}

export default Divers;
